import React from "react";
import { Link } from "react-router-dom";
import { LeftOutlined } from "@ant-design/icons";
import PageContainer from "../../components/PageContainer";
import MenuItem from "./MenuItem";
import {
  RootCategoriesTypes,
  ContractsAndJudicialDocumentsTypes,
} from "../../constant/Types";

const Home = (isParent = true) => {
  return (
    <PageContainer
      headerProps={{
        className: "home-header-holder",
        children: (
          <>
            <div className={"home-header"}>
              <h1 className="title"> لاوین </h1>
              <h2 className="sub-title"> دفتر مجازی وکلای دادگستری ایران</h2>
            </div>
          </>
        ),
        left: (
          <Link to={isParent ? "/home" : "/consulting"}>
            <LeftOutlined />
          </Link>
        ),
        tall: true,
      }}
      classNames={"home "}
    >
      <div className={"home-menu"}>
        {Object.entries(
          isParent ? RootCategoriesTypes : ContractsAndJudicialDocumentsTypes
        ).map(([key, value]) => {
          return (
            <MenuItem
              key={key}
              text={value.value}
              link={value.url}
              icon={value.icon}
              item={value}
            />
          );
        })}
      </div>
    </PageContainer>
  );
};

const JudicialDocuments = () => Home(false);

export default Home;
export { JudicialDocuments };
